import { Button } from "../ui/button";
import { Form } from "../ui/form";
import { membersRegistrationFormSchema } from "@/lib/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import CustomInput from "../myProfile/CustomInput";
import { useToast } from "@/components/hooks/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMember } from "@/api/apiFunction";
import moment from "moment";
import { useState } from "react";
import { Loader2, Pencil } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger } from "../ui/dialog";
interface UpdatedInfo {
  id: string;
  name?: string;
  birthDate?: string;
  gender?: "MALE" | "FEMALE" | "OTHER";
  email?: string;
  mobile?: string;
  jerseySize?: string;
  bloodGroup?: string;
  // isPrimary?: boolean;
}

interface UpdateMemberFormData {
  name: string;
  birthDate: string;
  gender?: string;
  email: string;
  mobile: string;
  phoneCode: string;
  jerseySize?: string;
  bloodGroup?: string;
  // sameAsPrimary: boolean;
}

const UpdatedMemberRegistration = ({
  updatedInfo,
}: {
  updatedInfo: UpdatedInfo;
}) => {
  // const [isSameAsPrimary, setIsSameAsPrimary] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //@ts-ignore
  const [user, setUser] = useState<UpdateMemberFormData | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const { toast } = useToast();
  const formSchema = membersRegistrationFormSchema();
  const queryClient = useQueryClient();

  // update members
  const { mutate } = useMutation({
    mutationFn: (userData: UpdateMemberFormData) =>
      //@ts-ignore
      updateMember(updatedInfo.id, userData),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-members"] });
      setOpenDialog(false);
      toast({
        title: "Member's data is updated successfully!",
        variant: "default",
      });
    },
    onError: (error) => {
      console.error("Error submitting Error while updating a member:", error);
      toast({
        title: "Error while updating a member!",
        description: "Please Try again",
        variant: "destructive",
      });
    },
  });
  // console.log("birthdate", updatedInfo?.isPrimary);
  const isoDate = updatedInfo?.birthDate;
  const formattedDate = isoDate ? moment(isoDate).format("YYYY-MM-DD") : "";
  // 1. Define Form
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),

    defaultValues: {
      name: updatedInfo?.name || "",
      dateOfBirth: formattedDate,
      gender: updatedInfo?.gender as "MALE" | "FEMALE" | "OTHER" | undefined,
      email: updatedInfo?.email || "",
      mobile: updatedInfo?.mobile || "",
      jerseySize: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"].includes(
        updatedInfo?.jerseySize ?? ""
      )
        ? (updatedInfo?.jerseySize as
            | "XS"
            | "S"
            | "M"
            | "L"
            | "XL"
            | "2XL"
            | "3XL"
            | "4XL")
        : undefined,
      bloodGroup: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].includes(
        updatedInfo?.bloodGroup ?? ""
      )
        ? (updatedInfo?.bloodGroup as
            | "A+"
            | "A-"
            | "B+"
            | "B-"
            | "AB+"
            | "AB-"
            | "O+"
            | "O-")
        : undefined,
    },
  });

  // const handlePrimaryNumberChange = (e) => {
  //   const value = e.target.value;
  //   setPrimaryNumber(value);
  //   if (isSameAsPrimary) {
  //     form.setValue("mobile", value);
  //   }
  // };

  // interface CheckboxChangeEvent {
  //   target: {
  //     checked: boolean;
  //   };
  // }

  // const handleCheckboxChange = (e: CheckboxChangeEvent) => {
  //   setIsSameAsPrimary(e.target.checked);
  //   form.setValue("sameAsPrimary", e.target.checked);
  //   if (e.target.checked) {
  //     form.setValue(
  //       "mobile",
  //       e.target.checked ? updatedInfo?.mobile || "" : ""
  //     );
  //   }
  // };

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    setIsLoading(true);

    try {
      const userData = {
        name: data.name,
        birthDate: data.dateOfBirth,
        gender: data.gender ?? "",
        email: data.email,
        mobile: data.mobile,
        phoneCode: "+91",
        jerseySize: data.jerseySize,
        bloodGroup: data.bloodGroup,
        // sameAsPrimary: data.sameAsPrimary,
      };

      setUser(userData);
      mutate(userData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="w-full">
      <Dialog open={openDialog} onOpenChange={setOpenDialog}>
        <DialogTrigger asChild>
          <div
            // onClick={() => setSelectedMember(member)}
            className="flex items-center  gap-2 cursor-pointer "
          >
            <Pencil size={16} />
          </div>
        </DialogTrigger>

        <DialogContent className="w-full  ">
          <Form {...form}>
            <form className="space-y-4 " onSubmit={form.handleSubmit(onSubmit)}>
              <div className="w-full flex flex-col gap-6 mx-auto ">
                <div className="w-full  flex flex-col-reverse items-center  md:flex-row gap-6  justify-between">
                  <div className=" flex flex-col gap-6 w-full">
                    <CustomInput
                      control={form.control}
                      name="name"
                      label="Full Name"
                      placeholder="Pranav Mahajan"
                      disabled={true}
                    />

                    {/* <div className="flex w-full justify-between gap-6">
                      <div className="relative w-full">
                        <CustomInput
                          type="date"
                          control={form.control}
                          name="dateOfBirth"
                          label="Date Of Birth"
                          placeholder="6/10/2006"
                          className="flex flex-col "
                          disabled={true}
                        />
                      </div>
                      <div className="w-full ">
                        <CustomInput
                          control={form.control}
                          name="bloodGroup"
                          label="Blood Group"
                          type="select"
                          className=""
                          placeholder="Select Blood  Group"
                          disabled={true}
                          options={[
                            "A+",
                            "A-",
                            "B+",
                            "B-",
                            "AB+",
                            "AB-",
                            "O+",
                            "O-",
                          ]}
                        />
                      </div>
                    </div>

                    <CustomInput
                      className="ml-6 flex"
                      control={form.control}
                      name="gender"
                      label="Gender"
                      type="radio"
                      options={["MALE", "FEMALE", "OTHER"]}
                      disabled={true}
                    /> */}
                  </div>
                </div>
                {/* <CustomInput
                  control={form.control}
                  name="email"
                  label="Email"
                  placeholder="example@example.com"
                  disabled={true}
                /> */}
                <div>
                  <CustomInput
                    control={form.control}
                    name="mobile"
                    label="Mobile"
                    placeholder="+91xxxxxxxxxx"
                    disabled={true}
                  />
                  {/* <label
                htmlFor="sameAsPrimary"
                className="flex mt-2 items-center space-x-2"
              >
                <span>Same as Primary</span>
                <input
                  type="checkbox"
                  className=" h-4 w-4 "
                  id="sameAsPrimary"
                  checked={isSameAsPrimary}
                  onChange={handleCheckboxChange}
                />
              </label> */}
                </div>

                <div className="">
                  <CustomInput
                    control={form.control}
                    name="jerseySize"
                    label="T-Shirt / Jersey"
                    type="radio"
                    className="grid grid-cols-4 mt-2  md:flex md:flex-wrap  md:space-x-6" // For horizontal alignment
                    options={["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"]}
                  />
                </div>

                <div className="flex flex-col justify-center  items-center gap-4">
                  <Button
                    type="submit"
                    disabled={isLoading}
                    className="form-btn w-36 font-semibold px-5 md:px-10  rounded-3xl bg-gradient-to-r from-[#4BD5D6] to-[#009FA6]"
                  >
                    {isLoading ? (
                      <>
                        //@ts-ignore
                        <Loader2 size={20} className="animate-spin" /> &nbsp;
                        Loading...
                      </>
                    ) : (
                      "Save Changes"
                    )}
                  </Button>
                </div>
              </div>
            </form>
          </Form>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default UpdatedMemberRegistration;
